module.exports = __webpack_public_path__ + "static/media/button@2x.0626f0af.png";